import { ColorGrey7, ColorWhite, FreshAsphalt50 } from './palette';

export const CalendarCellBgColor = ColorWhite;
export const CalendarCellColor = FreshAsphalt50;
export const WeekCellColor = ColorGrey7;
